import { setSchemaMessage } from "valibot";
setSchemaMessage(
  (issue) => `Typage invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);